import { useMemo } from 'react';

import { IRow, TInvalidRows } from '../../../../types/addressBook';

interface IProps {
  rows: IRow[];
  invalidRows: TInvalidRows;
  showIssuesOnly: boolean;
  searchQuery: string;
}

export const useFilteredRows = ({ rows, invalidRows, showIssuesOnly, searchQuery }: IProps) => {
  const filteredRows = useMemo(() => {
    let filtered = rows;

    if (showIssuesOnly) {
      filtered = filtered.filter((row) => {
        const rowErrors = invalidRows[row.id];
        return rowErrors && Object.keys(rowErrors).length > 0;
      });
    }

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((row) => {
        return Object.values(row).some((value) => String(value).toLowerCase().includes(query));
      });
    }

    return filtered;
  }, [rows, invalidRows, showIssuesOnly, searchQuery]);

  const hasNoIssues = useMemo(() => {
    return Object.values(invalidRows).every((row) => !row || Object.keys(row).length === 0);
  }, [invalidRows]);

  return {
    filteredRows,
    hasNoIssues,
  };
};
